import { AnyAction } from 'redux';

import { CategoriesReceivedAction, CATEGORIES_RECEIVED } from '@ttstr/actions';
import { Articles, IndexedCategories, Product } from '@ttstr/api';
import { AppState } from '.';

export interface ReduxState {
  categoriesReceived: boolean;
  categories: IndexedCategories;
}

const initialState: ReduxState = {
  categoriesReceived: false,
  categories: {},
};

const Categories = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case CATEGORIES_RECEIVED: {
      const { categories } = (action as CategoriesReceivedAction).payload;

      if (!categories) return state;

      return {
        ...state,
        categoriesReceived: true,
        categories: categories.reduce(
          (previous, current) => ({
            ...previous,
            [current.id]: current,
          }),
          {}
        ),
      };
    }
    default:
      return state;
  }
};

export const getCategories = (state: AppState) => {
  return state.Categories.categories;
};

export const getCategoriesReceived = (state: AppState) => {
  return state.Categories.categoriesReceived;
};

export const getCategoriesFromProduct = (categories: IndexedCategories, product: Product) => {
  if (!product) return [];
  if (!product.category_ids) return [];

  return product.category_ids.map((id) => categories[id]);
};

export const getCategoriesForProducts = (categories: IndexedCategories, products: Articles) => {
  if (!categories) return {};
  return Object.entries(categories).reduce<IndexedCategories>(
    (acc, [id, category]) =>
      products.some((p) => p.category_ids.includes(Number(id))) ? { ...acc, [id]: category } : acc,
    {}
  );
};

export default Categories;
